import SignaturePad from 'signature_pad'

export default function pad(sign_image, im_input){
  var wrapper = document.getElementById("signature-pad");
  var clearButton = wrapper.querySelector("[data-action=clear]");
  var undoButton = wrapper.querySelector("[data-action=undo]");
  var canvas = wrapper.querySelector("canvas");
  var signaturePad = new SignaturePad(canvas, {
    // It's Necessary to use an opaque color when saving image as JPEG;
    // this option can be omitted if only saving as PNG or SVG
    backgroundColor: 'rgb(255, 255, 255)'
  });

  function resizeCanvas() {
    // When zoomed out to less than 100%, for some very strange reason,
    // some browsers report devicePixelRatio as less than 1
    // and only part of the canvas is cleared then.
    var ratio =  Math.max(window.devicePixelRatio || 1, 1);

    // This part causes the canvas to be cleared
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext("2d").scale(ratio, ratio);

    signaturePad.clear();

    if (sign_image !== undefined) {
      signaturePad.fromData(sign_image);
    }
  }

  window.onresize = resizeCanvas;
  resizeCanvas();

  if (clearButton) {
    clearButton.addEventListener("click", function (event) {
      signaturePad.clear();
      im_input.val('')
    });
  }

  if (undoButton) {
    undoButton.addEventListener("click", function (event) {
      var data = signaturePad.toData();

      if (data) {
        data.pop(); // remove the last dot or line
        signaturePad.fromData(data);
      }
    });
  }

  if (sign_image !== undefined) {
    signaturePad.fromData(sign_image);
  }

  return signaturePad;
}